// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"l4-z","colorTextValue":"m4-z","swatches":"n4-z","collapseLink":"o4-z","isCollapsed":"p4-z","dropdown":"q4-z","disabled":"r4-z"};